module.exports = __webpack_public_path__ + "img/cat.05b508ad.jpeg";